import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

export default function PopoverDropdown({
  children,
  content,
  buttonLabel = "popover button",
}) {
  return (
    <Popover>
      {({ open }) => (
        <>
          <PopoverButton className="bg-chestnut-rose h-10 px-3 py-2 rounded-md text-white">
            {buttonLabel}
          </PopoverButton>
          {open && (
            <PopoverPanel
              transition
              anchor="bottom"
              className="relative z-0 before:content-[''] before:absolute before:!bg-black/20 before:w-4 before:h-4 before:top-0 before:left-1/2 before:right-1/2 before:-translate-x-1/2 before:shadow-lg before:rotate-45 before:-z-[1] !overflow-visible mt-1"
            >
              <div className="bg-white shadow-md rounded-md min-w-60 max-w-auto relative border border-chestnut-rose bg-chestnut-rose/10 p-3 mt-[5px]">
                <div>{children || content}</div>
              </div>
            </PopoverPanel>
          )}
        </>
      )}
    </Popover>
  );
}

// divide-y divide-white/5 rounded-xl bg-white/5 text-sm/6 transition duration-200 ease-in-out [--anchor-gap:--spacing(5)] data-closed:-translate-y-1 data-closed:opacity-0
